import type Stripe from 'stripe-latest';

import Card from '../../../generic/Card/Card';
import Flex from '../../../generic/Flex';
import {
  getPlanLabel,
  isBusinessPlan,
  isEnterprisePlan,
  isFreePlan,
  planIcon,
} from '../utils';
import type { StripePriceLimitType } from '../../../../../shared/model-typings/stripepricelimits';

import DisplayBusinessPlan from './DisplayBusinessPlan';
import DisplayEnterprisePlan from './DisplayEnterprisePlan';
import DisplayFreePlan from './DisplayFreePlan';
import { usePlansContext } from './PlansContext';

import styles from './styles.module.less';

const PlanCards = () => {
  const { plans } = usePlansContext();

  if (!plans) {
    return null;
  }

  return (
    <Flex direction="row" align="unset" gap={32}>
      {plans.map((plan) => {
        const price = plan.prices[0] as Stripe.Price;
        const product = price.product as Stripe.Product;
        const isFree = isFreePlan(product);
        const isBusiness = isBusinessPlan(product);
        const isEnterprise = isEnterprisePlan(product);
        return (
          <Flex direction="row" align="unset" key={product.name} className={styles.cardContainer}>
            <Card
              isFullWidth
              isContentFullHeight
              variant="fill"
              key={product.name}
            >
              <Card.Content>
                <div className={styles.cardContentContainer}>
                  <Flex direction="column" align="flex-start" justify="flex-start" gap={20}>
                    <img src={planIcon(product.metadata?.type as StripePriceLimitType)} alt={product.name} />

                    <div className={styles.planName}>
                      {getPlanLabel(product)}
                    </div>

                    <div className={styles.planDescription}>
                      {product.description}
                    </div>
                    {isFree && <DisplayFreePlan />}
                    {isBusiness && <DisplayBusinessPlan />}
                    {isEnterprise && <DisplayEnterprisePlan />}
                  </Flex>
                </div>
              </Card.Content>
            </Card>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default PlanCards;
